@for (block of pageBlocks; track block) {
  <div
    [ngClass]="[block.bundle, 'block']"
    [bundle]="block.bundle"
    [blockBackground]="block"
    [crop]="block.mediaBackground?.crop"
    [class.has-background]="block.backgroundColor || block.mediaBackground || block.backgroundVideo">
    @switch (block.bundle) {
      @case (blockTypes.BLOCK_IMAGE_TEXT) {
        <app-text-image [block]="block"></app-text-image>
      }
      @case (blockTypes.BLOCK_LOGIN_PROMO) {
        <app-login-promo [block]="block"></app-login-promo>
      }
      @case (blockTypes.BLOCK_FEATURE_HIGHLIGHT) {
        <app-feature-highlight [block]="block"></app-feature-highlight>
      }
      @case (blockTypes.BLOCK_VIDEO) {
        <app-video-block [block]="block"></app-video-block>
      }
      @case (blockTypes.BLOCK_FULL_SCREEN_BANNER) {
        <app-banner-block [block]="block"></app-banner-block>
      }
      @case (blockTypes.BLOCK_TESTIMONIALS) {
        <app-testimonials [block]="block"></app-testimonials>
      }
      @case (blockTypes.BLOCK_DISOVER_CONTENT) {
        <app-discover-content-block [block]="block"></app-discover-content-block>
      }
      @case (blockTypes.BLOCK_CAROUSEL) {
        <app-carousel-block [block]="block"></app-carousel-block>
      }
      @case (blockTypes.BLOCK_LEARNING_PATH) {
        @if (block.contents?.length) {
          <app-learning-path-block [block]="block"></app-learning-path-block>
        }
      }
      @case (blockTypes.BLOCK_CONTENT_HIGHTLIGHT) {
        <app-content-highlight-block [block]="block"></app-content-highlight-block>
      }
      @case (blockTypes.BLOCK_CHALLENGES_LIST) {
        @if (block.contents?.length) {
          <app-challenge-block  [block]="block"></app-challenge-block >
        }
      }
      @case (blockTypes.BLOCK_DASHBOARD_HIGHLIGHTS) {
        <app-dashboard-highlights-block [block]="block"></app-dashboard-highlights-block>
      }
      @case (blockTypes.BLOCK_PROMOTION) {
        <app-promotion-block [block]="block"></app-promotion-block>
      }
      @case (blockTypes.BLOCK_WEBINARS) {
        <app-webinars-block [block]="block"></app-webinars-block>
      }
    }
  </div>
}